import { USER, CONVERSATION, ONBOARD } from '~/consts'

export default {
  computed: {
    search_contact: {
      get() {
        let search = collect(this.contactDataProvider.criterion).where('criteria', '==', 'name,email').first();

        if (!this.isEmpty(search)) {
          return search.value
        }

        return ''
      },
      set(val) {
        let search = collect(this.contactDataProvider.criterion).where('criteria', '==', 'name,email').first();

        if (!this.isEmpty(search)) {
          this.contactDataProvider.criterion = collect(this.contactDataProvider.criterion).map((c) => {
            if (c.criteria == 'name,email') {
              c['value'] = val
            }

            return c;
          }).toArray()
        } else {
          this.contactDataProvider.criterion.push({criteria: 'name,email', value: val, operator: 'LK'})
        }
      }
    },
    search_mentionable_user: {
      get() {
        let search = collect(this.mentionableUserDataProvider.criterion).where('criteria', '==', 'search').first();

        if (!this.isEmpty(search)) {
          return search.value
        }

        return ''
      },
      set(val) {
        let search = collect(this.mentionableUserDataProvider.criterion).where('criteria', '==', 'search').first();

        if (!this.isEmpty(search)) {
          this.mentionableUserDataProvider.criterion = collect(this.mentionableUserDataProvider.criterion).map((c) => {
            if (c.criteria == 'search') {
              c['value'] = val
              c['custom'] = true
            }

            return c;
          }).toArray()
        } else {
          this.mentionableUserDataProvider.criterion.push({criteria: 'search', value: val, operator: 'LK', 'custom': true})
        }
      }
    }
  },

  data() {
    return {
      loading_get_mentionable_users: false,
      loading_get_mentionable_users_refresh: false,
      loading_get_contacts: false,
      loading_get_contacts_refresh: false,
      contactDataProvider: {
        page: {
          current: 1
        },
        criterion: []
      },
      mentionableUserDataProvider: {
        page: {
          current: 1
        },
        criterion: []
      },
      loading_get_user_meta: false,
      loading_update_profile: false,
      loading_get_verification_code: false,
    }
  },

  methods: {
    onGetPaginatedContactsSuccess() {},
    onGetPaginatedContactsFailed() {},
    getContacts(refresh = false) {
      const vm = this;

      if (refresh) {
        vm.loading_get_contacts_refresh = true
        vm.contactDataProvider.page['current'] = 1
      } else {
        vm.loading_get_contacts = true
      }

      this.$axios.post(CONVERSATION.GET_CONTACTS, {
        dataProvider: JSON.stringify(vm.contactDataProvider)
      })
        .then(({ data }) => {
          if (data.applicationSystem.code == 0) {
            let contacts = data.data.data

            if (!refresh) {
              contacts = collect(vm.contacts).merge(contacts).toArray();
            }

            vm.contactDataProvider = data.data.dataProvider

            vm.onGetPaginatedContactsSuccess(contacts);
          }

          vm.loading_get_contacts = false
          vm.loading_get_contacts_refresh = false
        })
        .catch(() => {
          vm.onGetPaginatedContactsFailed();
          vm.loading_get_contacts = false
          vm.loading_get_contacts_refresh = false
        })
    },

    onGetMentionableUsersSuccess() {},
    onGetMentionableUsersFailed() {},
    getMentionableUsers(refresh = false) {
      const vm = this;

      if (refresh) {
        vm.loading_get_mentionable_users_refresh = true
        vm.mentionableUserDataProvider.page['current'] = 1
      } else {
        vm.loading_get_mentionable_users = true
      }

      this.$axios.post(USER.GET_MENTIONABLE_USERS, {
        dataProvider: JSON.stringify(vm.mentionableUserDataProvider)
      })
        .then(({ data }) => {
          if (data.applicationSystem.code == 0) {
            let users = data.data.data

            if (!refresh) {
              users = collect(vm.users).merge(users).toArray();
            }

            vm.mentionableUserDataProvider = data.data.dataProvider

            vm.onGetMentionableUsersSuccess(users);
          }

          vm.loading_get_mentionable_users = false
          vm.loading_get_mentionable_users_refresh = false
        })
        .catch(() => {
          vm.onGetMentionableUsersFailed();
          vm.loading_get_mentionable_users = false
          vm.loading_get_mentionable_users_refresh = false
        })
    },

    onGetUserMetaSuccess() {},
    onGetUserMetaFailed() {},
    getUserMeta(username) {
      const vm = this

      vm.loading_get_user_meta = true

      this.$axios.post(USER.GET_META(username))
        .then(({ data }) => {
          if (data.applicationSystem.code == 0) {
            vm.onGetUserMetaSuccess(data);
          } else {
            vm.onGetUserMetaFailed();
          }

          vm.loading_get_user_meta = false
        })
        .catch(() => {
          vm.onGetUserMetaFailed();
          vm.loading_get_user_meta = false
        })
    },

    onUpdateProfileSuccess() {},
    onUpdateProfileFailed(msg) {
      toast.danger(msg)
    },
    updateProfile(data) {
      const vm = this

      if (vm.loading_update_profile) {
        return;
      }

      vm.loading_update_profile = true

      this.$axios.post(USER.UPDATE_PROFILE_DATA, {
        media_id: data.media_id,
        name: data.name,
        phone: data.phone,
        gender: data.gender,
        meta: {
          introduction: data.meta.introduction,
          website: data.meta.website,
          facebook_url: data.meta.facebook_url,
          twitter_url: data.meta.twitter_url,
          linkedin_url: data.meta.linkedin_url,
        }
      })
        .then(({ data }) => {
          if (data.applicationSystem.code == 0) {
            vm.onUpdateProfileSuccess(data);
          } else {
            vm.onUpdateProfileFailed(data.applicationSystem.message);
          }

          vm.loading_update_profile = false
        })
        .catch(() => {
          vm.onUpdateProfileFailed('Gagal mengubah profile');

          vm.loading_update_profile = false
        })
    },

    onSaveUserSuccess() {},
    onSaveUserFailed() {},
    saveUser() {
      const vm = this

      this.$axios.post(USER.CREATE, {
        email: this.selected_user.email,
        name: this.selected_user.name,
        status: this.selected_user.status,
      })
      .then(({ data }) => {
        if (data.applicationSystem.code == 0) {
          this.onSaveUserSuccess(data);
        } else {
          this.onSaveUserFailed(data);
        }
      })
      .catch(() => {
      })
    },

    async getVerificationCode(email) {
      if (this.loading_get_verification_code === true) {
        return;
      }

      this.loading_get_verification_code = true;
      try {
        const { data } = await this.$axios.post(ONBOARD.GET_VERIFICATION_CODE, {
          email: email
        });

        if (data.applicationSystem.code === 0) {
          toast.default(data.applicationSystem.message);
        } else {
          toast.danger(data.applicationSystem.message);
        }
      } catch (e) {}

      this.loading_get_verification_code = false;
    }
  }
}
